const Spinner = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div
        style={{ width: "3rem", height: "3rem" }}
        className="spinner-border text-primary"
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
